import { IApiObterDetalhesContratoResponse } from "@hooks/api/contracts";

import { PRODUCT_CODE, PRODUCT_STATUS, PRODUCT_TYPE } from "./enums";
import { isCardProductType } from "./card";

export const getProductTypeFromProductCode = (productCode: PRODUCT_CODE) => {
  switch (productCode) {
    case PRODUCT_CODE.MARGEM_LIVRE:
      return PRODUCT_TYPE.MARGEM_LIVRE;
    case PRODUCT_CODE.MARGEM_LIVRE_AUMENTO:
      return PRODUCT_TYPE.MARGEM_LIVRE_AUMENTO;
    case PRODUCT_CODE.CARTAO_BENEFICIO:
      return PRODUCT_TYPE.CARTAO_BENEFICIO;
    case PRODUCT_CODE.PORTABILIDADE:
      return PRODUCT_TYPE.PORTABILIDADE;
    case PRODUCT_CODE.SAQUE_COMPLEMENTAR:
      return PRODUCT_TYPE.SAQUE_COMPLEMENTAR;
    case PRODUCT_CODE.PORTABILIDADE_REFIN:
      return PRODUCT_TYPE.PORTABILIDADE_REFIN;
    case PRODUCT_CODE.REFINANCIAMENTO:
      return PRODUCT_TYPE.REFINANCIAMENTO;
    case PRODUCT_CODE.CARTAO_CONSIGNADO:
      return PRODUCT_TYPE.CARTAO_CONSIGNADO;
    case PRODUCT_CODE.REFIN_SAQUE_CARTAO:
      return PRODUCT_TYPE.REFIN_CARTAO;
    case PRODUCT_CODE.AGREGACAO_MARGEM_CARTAO:
      return PRODUCT_TYPE.AGREGACAO_MARGEM;
    case PRODUCT_CODE.RECEBA:
      return PRODUCT_TYPE.RECEBA;
    case PRODUCT_CODE.CONSIGNADO_PRIVADO:
      return PRODUCT_TYPE.CONSIGNADO_PRIVADO;
    default:
      return PRODUCT_TYPE.TODOS_PRODUTOS;
  }
};

export const getProductStatus = (data: IApiObterDetalhesContratoResponse) => {
  if (
    data.tipo_produto !== PRODUCT_TYPE.SAQUE_COMPLEMENTAR &&
    isCardProductType(data.tipo_produto)
  ) {
    return data.cartao_beneficio.status;
  }

  switch (data.tipo_produto) {
    case PRODUCT_TYPE.SAQUE_COMPLEMENTAR:
      return data.saque_complementar.status;
    case PRODUCT_TYPE.MARGEM_LIVRE:
      return data.margem_livre.status;
    case PRODUCT_TYPE.PORTABILIDADE:
      return data.portabilidade.status;
    case PRODUCT_TYPE.PORTABILIDADE_REFIN:
      return data.portabilidade_refin?.status_port;
    case PRODUCT_TYPE.REFINANCIAMENTO:
      return data.refinanciamento?.status;
    case PRODUCT_TYPE.AGREGACAO_MARGEM:
      return data.agregacao_de_margem?.status;

    default:
      return undefined;
  }
};

export const isDocumentPendingStatus = (status?: PRODUCT_STATUS) => {
  if (!status) return false;

  return [
    PRODUCT_STATUS.PENDENTE_DOCUMENTACAO,
    PRODUCT_STATUS.PENDENTE_DOCUMENTACAO_MESA_CORBAN,
  ].includes(status);
};
